module.exports = __webpack_public_path__ + "img/aqua-blue.5ffcd6fa.png";